import AgeonLogo from '../components/AgeonLogo';
import ForgotPasswordForm from '../components/ForgotPassword';

export default function ForgotPasswordPage() {
    return (
        <div className="min-h-screen grid lg:grid-cols-2 bg-white">
            <div className="hidden lg:flex flex-col justify-between p-10 bg-gradient-to-br from-brand-teal to-brand-teal-700 text-white">
                <AgeonLogo variant="white" />
                <div>
                    <h1 className="text-4xl font-extrabold leading-tight max-w-md">
                        Reset your password securely.
                    </h1>
                    <p className="mt-4 text-white/80 max-w-md">
                        We&rsquo;ll email a one-time code to verify it&rsquo;s you, then you can set a new password.
                    </p>
                </div>
                <div className="text-xs text-white/70">© {new Date().getFullYear()} EBG x AGEON</div>
            </div>

            <div className="flex items-center justify-center p-6 lg:p-10">
                <div className="w-full max-w-sm">
                    <div className="lg:hidden mb-6"><AgeonLogo /></div>
                    <ForgotPasswordForm />
                </div>
            </div>
        </div>
    );
}
